import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiError } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = authed
  const [meta, setMeta] = useState(null);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("hrms_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("hrms_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  useEffect(() => {
    if (user && user !== false && !meta) {
      api.get("/meta").then(({ data }) => setMeta(data)).catch(() => {});
    }
  }, [user, meta]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hrms_token", data.token);
      setUser(data.user);
      await loadMe();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("hrms_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, meta, login, logout, refresh: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}
